import styled from "styled-components";

export const StyledAdditionForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
`;

export const StyledEmojiRow = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  padding: 0 10px;
`;

export const StyledHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StyledCloseButton = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

export const StyledDialsList = styled.div`
  max-height: 20vh;
  overflow: scroll;
  margin-bottom: 16px;
`;
